import React from "react";

import BeerLists from "../BeerLists";
import Content from "../Content";
import FramedTitle from "../FramedTitle";
import Hero from "../Hero";

import heroNarrow from "./images/narrow-taps.jpg";
import hero from "./images/taps.jpg";

const DrinkInMenu = () => (
  <>
    <Hero src={hero} narrowSrc={heroNarrow} bottom />
    <Content>
      <FramedTitle text="Drinks" />
      <BeerLists />
    </Content>
  </>
);

export default DrinkInMenu;
